import request from "@/api/request";
import { Video } from "@/interfaces/Video/Video";
import { SignupResponse } from "@/interfaces/Freearea/SignupResponse.ts";
import { SignupParams } from "@/interfaces/Freearea/SignupParams.ts";

class FreeareaService {
  static async signup(props: SignupParams): Promise<SignupResponse> {
    return await request.post("/freearea/signup", props);
  }

  static async subscribe(email: string): Promise<void> {
    return await request.put(`/freearea/subscribe`, { email });
  }

  static async getStaffPicks(): Promise<Video[]> {
    return await request.get("/freearea/staff_picks");
  }
}

export default FreeareaService;
